
import React, { useState } from 'react';

const Pb2023 = () => {
    const [contador, setContador] = useState(0);
    const suma = () => {
        setContador(contador + 1)
    }

    const enlacesExternos = [
        
        'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/Beneficiarios_X_Conc_Estat_Artesanias_HEH_Jul_2023.pdf',
        'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/FomentoArtesanal.pdf',
        'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/Migrantes_PUB_3erTrim_2023.pdf',
        'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/Migrantes.pdf',
        'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/PDB_SUB_OD.pdf',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
        // 'https://www.example.com',
    ];

    const nombresEnlaces = [
        
        'Padrón de Personas Beneficiarias Fomento Artesanal 3er Trimestre 2023,',
        'Padrón de Personas Beneficiarias Fomento Artesanal 2do Trimestre 2023',
        'Padrón de Personas Beneficiarias 3er Trimestre 2023 de la Dirección de Atención al Migrante',
        'Padrón de Personas Beneficiarias 2do Trimestre 2023 de la Dirección de Atención al Migrante', 
        'Padrón de Beneficiarios de Subsidios a Organizaciones Diversas',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
        // 'Enlace personalizado',
    ];

    const dividirEnFilas = (array, size) => {
        const filas = [];
        for (let i = 0; i < array.length; i += size) {
            filas.push(array.slice(i, i + size));
        }
        return filas;
    };

    const filasDeEnlaces = dividirEnFilas(enlacesExternos, 5);

    return (
        <div className='container container-mh'>
            <div className='row'>
                <div className='col-12'>
                    <h3 className='title'>Padrones de beneficiarios 2023</h3>
                    <hr className='hr-gob' />
                </div>
            </div>
            <div className='row justify-content-center'>
                <div className='col-sm-12'>
                    {filasDeEnlaces.map((fila, index) => (
                        <React.Fragment key={index}>
                            <div className="row justify-content-center">
                                {fila.map((enlace, enlaceIndex) => (
                                    <div key={enlaceIndex} className="col-sm-2">
                                        <a href={enlace} target="_blank" rel="noopener noreferrer">
                                            {nombresEnlaces[enlaceIndex + index * 5]}
                                        </a>
                                    </div>
                                ))}
                            </div>
                            <hr /> {/* Línea horizontal entre las filas */}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Pb2023;